var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsDetailsBg"},[_c('div',{staticClass:"newsDetailsWd"},[_c('el-card',[_c('div',[_c('p',{staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(_vm.newsDetail.title))])]),_c('div',{staticClass:"newsDetailTop"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.newsDetailContent.content)}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }